(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
